$('.hpe-number-input__control').click(function () {
  const input = $(this)
    .parent()
    .find('input');
  const inputVal = parseInt(input.val(), 10);
  const inputMin = parseInt(input.attr('min'), 10);
  const inputMax = parseInt(input.attr('max'), 10);
  const incrementAmount = parseInt($(this).attr('data-amount'), 10);
  const addButton = $(this)
    .parent()
    .children('.hpe-number-input__control--add');
  const subtractButton = $(this)
    .parent()
    .children('.hpe-number-input__control--subtract');

  if (inputVal <= inputMin && incrementAmount < 0) {
    $(input).val(inputMin);
    subtractButton.attr('disabled', true);
  } else if (inputVal >= inputMax && incrementAmount > 0) {
    $(input).val(inputMax);
    addButton.attr('disabled', true);
  } else {
    $(input).val(inputVal + incrementAmount);
    addButton.attr('disabled', false);
    subtractButton.attr('disabled', false);
  }
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/number-input.js